import { config } from './config';

const stripTrailingSlash = (value = '') => value.replace(/\/+$/, '');

export const normalizeSlug = (slug = '') => {
  if (!slug) return '';
  return slug
    .toString()
    .trim()
    .replace(/^\/+/, '')
    .replace(/\/+$/, '')
    .toLowerCase();
};

const getBaseUrl = () => stripTrailingSlash(config.getBaseUrl());

export const buildArtistPublicUrl = (slug) => {
  const normalized = normalizeSlug(slug);
  if (!normalized) return null;
  return `${getBaseUrl()}/${normalized}`;
};

export const buildKaraokePublicUrl = (slug) => {
  const normalized = normalizeSlug(slug);
  if (!normalized) return null;
  return `${getBaseUrl()}/karaoke/${normalized}`;
};

export const buildKaraokeTvUrl = (slug) => {
  const normalized = normalizeSlug(slug);
  if (!normalized) return null;
  return `${getBaseUrl()}/karaoke/${normalized}/tv`;
};

export const buildKaraokeTvControlUrl = (slug) => {
  const normalized = normalizeSlug(slug);
  if (!normalized) return null;
  return `${getBaseUrl()}/karaoke/${normalized}/tv-control`;
};

